export const carouselTheme = {
  transitionDuration: '0.2s',
  extend: {
    agility: {
      content: {
        padding: '24px 0',
      },
      item: {
        selected: {
          color: 'var(--primary-color)',
        },
      },
      button: {
        next: {
          margin: {
            right: '16px',
            left: '8px',
          },
        },
        prev: {
          margin: {
            left: '16px',
            right: '8px',
          },
        },
        width: 'var(--two-rem)',
        height: 'var(--two-rem)',
        border: 'var(--reset-none)',
        background: 'var(--transparent)',
        color: 'var(--primary-color)',
        borderRadius: 'var(--pct-50)',
        hover: {
          color: 'var(--white)',
          border: 'var(--transparent)',
          background: 'var(--slate-600)',
        },
        icon: {
          width: 'var(--font-size-xl)',
          height: 'var(--font-size-xl)',
        },
      },
    },
  },
  css: ({ dt }: any) => `
    .p-carousel-viewport {
      padding: ${dt('carousel.agility.content.padding')};
    }
    .p-carousel-item {
      position: relative;
    }
    .p-carousel-item .selected::after {
      content: '';
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-top: 7px solid ${dt('carousel.agility.item.selected.color')};
      position: absolute;
      display: block;
      bottom: -14px;
      left: 50%;
      margin-left: -6px;
      cursor: auto;
    }
    .p-carousel-prev-button button, .p-carousel-next-button button {
      width: ${dt('carousel.agility.button.width')} !important;
      height: ${dt('carousel.agility.button.height')} !important;
      color: ${dt('carousel.agility.button.color')} !important;
      border: ${dt('carousel.agility.button.border')} !important;
      background: ${dt('carousel.agility.button.background')} !important;
      border-radius: ${dt('carousel.agility.button.border.radius')} !important;

      svg {
        width: ${dt('carousel.agility.button.icon.width')} !important;
        height: ${dt('carousel.agility.button.icon.height')} !important;
      }
    }
    .p-carousel-prev-button button:enabled:hover, .p-carousel-next-button button:enabled:hover {
      color: ${dt('carousel.agility.button.hover.color')} !important;
      border: ${dt('carousel.agility.button.hover.border')} !important;
      background: ${dt('carousel.agility.button.hover.background')} !important;
    }
    .p-carousel-prev-button {
      margin-left: ${dt('carousel.agility.button.prev.margin.left')} !important;
      margin-right: ${dt('carousel.agility.button.prev.margin.right')} !important;
    }
    .p-carousel-next-button {
      margin-right: ${dt('carousel.agility.button.next.margin.right')} !important;
      margin-left: ${dt('carousel.agility.button.next.margin.left')} !important;
    }

    .powerbi-carousel {
      .p-carousel-prev-button {
        margin-left: 0 !important;
        margin-right: ${dt('carousel.agility.button.prev.margin.right')} !important;
      }
      .p-carousel-next-button {
        margin-right: 0 !important;
        margin-left: ${dt('carousel.agility.button.next.margin.left')} !important;
      }
    }
  `,
};
